import React from 'react';
import { createRoot } from 'react-dom/client';
import 'wicg-inert';
import { registerSW } from 'virtual:pwa-register';
import { configureEnv } from '@jwp/ott-common/src/env';

import './modules/register';

import App from './App';

import { attachAccessibilityListener } from '#src/utils/accessibility';
import { ThemeProvider } from '../../../ThemeContext';
import env from '@jwp/ott-common/src/env';

// Collect env vars
configureEnv({
  APP_VERSION: import.meta.env.APP_VERSION,

  APP_API_BASE_URL: import.meta.env.APP_API_BASE_URL,
  APP_PLAYER_ID: import.meta.env.APP_PLAYER_ID,

  APP_DEFAULT_CONFIG_SOURCE: import.meta.env.APP_DEFAULT_CONFIG_SOURCE || import.meta.env.CONFIG_ID,
  APP_PLAYER_LICENSE_KEY: import.meta.env.APP_PLAYER_LICENSE_KEY,

  APP_FOOTER_TEXT: import.meta.env.APP_FOOTER_TEXT,
  APP_BODY_FONT: import.meta.env.APP_BODY_FONT,
  APP_BODY_ALT_FONT: import.meta.env.APP_BODY_ALT_FONT,

  APP_RELEASE_VERSION: import.meta.env.APP_RELEASE_VERSION,
  APP_COGNITO_DOMAIN: import.meta.env.APP_COGNITO_DOMAIN,
  APP_COGNITO_CLIENT_ID: import.meta.env.APP_COGNITO_CLIENT_ID,
  APP_REDIRECT_URI: import.meta.env.APP_REDIRECT_URI,
  APP_USER_POOL_ID: import.meta.env.APP_USER_POOL_ID,
  APP_GRAPHQL_ENDPOINT: import.meta.env.APP_GRAPHQL_ENDPOINT,
  APP_API_GRAPHQL_ENDPOINT: import.meta.env.APP_API_GRAPHQL_ENDPOINT,
  APP_BASE_URL: import.meta.env.APP_BASE_URL,
  APP_ANDROID_PLAY_STORE_URL: import.meta.env.APP_ANDROID_PLAY_STORE_URL,
  APP_IOS_APP_STORE_URL: import.meta.env.APP_IOS_APP_STORE_URL,

  APP_MYDASHBOARD_URL: import.meta.env.APP_MYDASHBOARD_URL,
});


attachAccessibilityListener();

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <ThemeProvider>
      <App />
    </ThemeProvider>,
  );
} else {
  console.info('Application - rootElement not found');
}

registerSW();
